import React from "react";
import { Link } from "react-router-dom";

// React-Icons

//Images
import Logo from "../Header/imgs/logo.jpg";

const Footer = () => {
  return (
    <>
      <footer className="w-full py-14">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <Link
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              to="/"
              className="flex flex-col sm:flex-row items-center justify-center mb-8">
              <img
                src={Logo}
                className="mr-3 w-96 sm:w-24 md:w-32 lg:w-96 h-auto transition-all duration-300"
                alt="Logo"
              />
            </Link>
            <ul className="text-lg flex font-medium items-center justify-center flex-col md:flex-row md:gap-8 transition-all duration-500 py-8 mb-10 border-b border-gray-200">
              <li>
                <Link
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  to="/"
                  className="text-gray-800 hover:text-gray-900">
                  الرئيسية
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  to="/services"
                  className="text-gray-800 hover:text-gray-900">
                  الخدمات
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  to="/aboutUs"
                  className="text-gray-800 hover:text-gray-900">
                  عن الشركة
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  to="/contactUs"
                  className="text-gray-800 hover:text-gray-900">
                  تواصل معنا
                </Link>
              </li>
            </ul>
            <span className="text-lg text-gray-500 text-center block">
              مرعي جميع الحقوق محفوظة 2024.©
            </span>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
